import styled from 'styled-components'

import { CommonMarginAndPadding } from 'components/layout'
import mediaQueries from 'components/media-queries'
import { common as e2eClasses } from 'constants/e2eClasses'

export const Page = styled.div`
  width: 100%;
  height: 100%;
`

export const Banner = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses.bannerImg}${props.e2eClass}`
}))`
  display: flex;

  min-height: ${({ minHeight }) => minHeight || '160px'};

  background-image: linear-gradient(
      to left,
      ${({ theme }) => theme.shadow.white05},
      ${({ theme }) => theme.shadow.white200}
    ),
    url(${({ srcImage }) => srcImage});

  background-repeat: no-repeat;
  background-position: ${({ imgPosition }) => imgPosition || 'center'};

  align-items: center;

  background-size: cover;

  ${mediaQueries.mobile`
    background-image: linear-gradient(
        to left,
        ${({ theme }) => theme.shadow.white75},
        ${({ theme }) => theme.shadow.white200}
      ),
      url(${({ srcImage }) => srcImage});
    min-height: ${({ mobileHeight, minHeight }) => (mobileHeight ? mobileHeight : minHeight)};
    height: 130px;
  `};
`

export const HeadingsContainer = styled.div`
  display: flex;

  ${CommonMarginAndPadding};

  color: ${({ theme }) => theme.colors.blue50};
  font-family: ${({ theme }) => theme.fonts.regular};
`

export const Title = styled.h2.attrs(props => ({
  className: props.e2eClass && `${e2eClasses.bannerTitle}${props.e2eClass}`
}))`
  font-size: 30px;

  ${mediaQueries.mobile`
    font-size: 24px;
  `};
`

export const SubTitle = styled.p`
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 20px;

  ${mediaQueries.mobile`
    font-size: 16px;
  `};
`

export const SubTitleContainer = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses.bannerSubTitle}${props.e2eClass}`
}))`
  width: 80%;
`

export const ChildrenWrapper = styled.div`
  ${CommonMarginAndPadding};
`
